import lockupSrc from './brand/lockup-ink.png'
import styles from './Logo.module.css'

/**
 * The YourDealPulse mark: three rising bars and the wordmark, from `brand/`.
 *
 * It says **Your**DealPulse and not "DealPulse" on purpose. Several other
 * companies use the shorter name — we are not on the first page of search for
 * it and we are first for "yourdealpulse" — so the product's own screens use
 * the name it can actually be found by. The reasoning is in
 * `docs/21_SEO_AND_INDEXING.md`; the decision predates this component.
 *
 * Sized by HEIGHT, not by filling its container. It renders in two places whose
 * widths are nothing alike — a 184px nav and a 360px sign-in card — and a mark
 * that fills whatever it is put in is a different size in each.
 */
export function Logo() {
  return <img className={styles.logo} src={lockupSrc} alt="YourDealPulse" />
}
